import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { Pagination } from "@mui/material";
import { FaUserFriends, FaFileAlt } from "react-icons/fa"; // Import Crew Icon
import CircularProgress from '@mui/material/CircularProgress';
import dayjs from "dayjs";

import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Modal,
  Tooltip
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../../Navbar/Navbar";
import baseURL from "../../config";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const CrewProfileTable = () => {
  const [crewProfiles, setCrewProfiles] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCrew, setTotalCrew] = useState(0)
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Loader state
  const itemsPerPage = 10;
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  // Fetch crew profiles
  const fetchCrewProfiles = async (page = 1, search = "") => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(`${baseURL}/api/getcrewprofile`, {
        params: { page, limit: itemsPerPage, search },
        headers: { Authorization: `Bearer ${token}` }
      });
      setCrewProfiles(response.data.data);
      // console.log("response.data.data", response.data.data)
      setTotalPages(response.data.totalPages);
      setTotalCrew(response.data.total)
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      // Only show loader when changing page
      if (searchTerm === "") setIsLoading(true);

      await fetchCrewProfiles(currentPage, searchTerm);
      setIsLoading(false);
    };

    fetchData();
  }, [currentPage, searchTerm]);


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchCrewProfiles(pageNumber, searchTerm);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleEdit = (crewProfile) => {
    navigate("/crewprofile",
      { state: { crewProfile, from: "CrewProfileTable" } });
  };

    // List of documents to display
  const documentMapping = [
    { key: "crewDocument", label: "Crew CV" },
    { key: "passportDocument", label: "Passport" },
    { key: "cdcDocument", label: "CDC" },
    { key: "stcwDocument", label: "STCW" },
    { key: "stsdsdDocument", label: "STSDSD" },
    { key: "pscrbDocument", label: "PSCRB" },
    { key: "watchkeepingDocument", label: "Watchkeeping" },
    { key: "CopDocument", label: "COP" },
    { key: "yellowfeverDocument", label: "YELLOW FEVER VACCINE" },
    { key: "CovidVaccineDocument", label: "COVID 19 VACCINE" },
    { key: "iloDocument", label: "ILO" },
    { key: "sidDocument", label: "SID" },
    { key: "h2sDocument", label: "H2S" },
    { key: "CrewPhotoDocument", label: "Crew Photo" },
    { key: "cookcocDocument", label: "Cook COC" },
    { key: "officercocDocument", label: "Officer COC" },
    { key: "gocDocument", label: "GOC" },
    { key: "gmdssDocument", label: "GMDSS" },
    { key: "huetDocument", label: "HUET" },
    { key: "highvoltageDocument", label: "High Voltage" },
    { key: "brmDocument", label: "BRM" },
    { key: "degreeDiplomaDocument", label: "Degree/Diploma" },
    { key: "bosietDocument", label: "BOSIET" },
    { key: "signContratDocument", label: "Signed Contract" },
    { key: "AFF", label: "Advanced Fire Fighting (AFF)" },
    { key: "MFA", label: "Medical First Aid (MFA)" },
    { key: "PSSR", label: "Personal Safety and Social Responsibility (PSSR)" },
    { key: "SSO", label: "Ship Security Officer (SSO)" },
    { key: "BTM", label: "Bridge Team Management (BTM)" },
    { key: "ECDIS", label: "ECDIS" },
    { key: "contract", label: "Contract" },
    { key: "BankDocument", label: "Bank Details" },
    { key: "watchkeepingDocumentthree", label: "Watchkeeping (3rd)" },
    { key: "CopDocumentthree", label: "COP (3rd)" },
    { key: "medicalcare", label: "Medical Care" },
    { key: "Foodhandling", label: "Food Handling" },
    { key: "FastRescueBoat", label: "Fast Rescue Boat" },
    { key: "HLA", label: "HLA" },
    { key: "ERM", label: "ERM" },
    { key: "COCVerification", label: "COC Verification" },
    { key: "GMDSSVerification", label: "GMDSS Verification" },
    { key: "MarlinTest", label: "Marlin Test" },
    { key: "PreSea", label: "Pre Sea" },
    { key: "GMDSSEndorsement", label: "GMDSS Endorsement" },
  ];

 // ✅ Handle Document Click
const handleDocumentClick = (documents) => {
  let docsArray = [];

  // If documents is already an array
  if (Array.isArray(documents)) {
    docsArray = documents
      .filter((doc) => doc?.filePath)
      .map((doc) => {
        let filePath = doc.filePath.replace(/\\/g, "/");

        if (!filePath.startsWith("http")) {
          if (filePath.startsWith("/Documents")) {
            filePath = `${backendBaseURL}${filePath}`;
          } else {
            filePath = `${baseURL}/${filePath}`;
          }
        }

        return {
          name: doc.name || "",
          fileName: doc.fileName || "Document",
          filePath,
        };
      });
  } 
  // If documents is an object
  else if (typeof documents === "object" && documents !== null) {
    docsArray = Object.entries(documents)
      .filter(([_, doc]) => doc?.filePath)
      .map(([key, doc]) => {
        let filePath = doc.filePath.replace(/\\/g, "/");

        if (!filePath.startsWith("http")) {
          if (filePath.startsWith("/Documents")) {
            filePath = `${backendBaseURL}${filePath}`;
          } else {
            filePath = `${baseURL}/${filePath}`;
          }
        }

        return {
          name: key,
          fileName: doc.fileName || key,
          filePath,
        };
      });
  }

  setSelectedDocument(docsArray);
  setModalOpen(true);
};


  // ✅ Open Modal with fixed doc mapping

  const handleOpenDocumentModal = () => {

    const docs = documentMapping
      .map((doc) => {
        let filePath = crewDetails?.[doc.key]?.filePath;

        if (filePath) {
          filePath = filePath.replace(/\\/g, "/");

          if (!filePath.startsWith("http")) {
            if (filePath.startsWith("/Documents")) {
              filePath = `${backendBaseURL}${filePath}`;
            } else {
              filePath = `${baseURL}/${filePath}`;
            }
          }
        }

        return {
          name: doc.label,
          filePath: filePath || null,
        };
      })
      .filter((doc) => doc.filePath);

    setSelectedDocument(docs);
    setModalTitle(
      `Crew Documents - ${crewDetails?.name || "N/A"} - ${
        crewDetails?.indosno || "N/A"
      }`
    );
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedDocument([]);
  };


  const GenerateResume = async (id) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(`${baseURL}/api/generate-cv/${id}`, {
        responseType: "blob", // Important to get the file as binary
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Trigger file download
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      // Optional: You could get filename from response headers if you send it
      a.download = `Allinz_Crew_Resume.docx`;
      a.click();

      // Clean up
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading resume:", error);
      toast.error("Failed to generate resume. Try again.");
    }
  };

  const GenerateZMIResume = async (id) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(`${baseURL}/api/generate-zmi-cv/${id}`, {
        responseType: "blob", // Important to get the file as binary
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Trigger file download
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      // Optional: You could get filename from response headers if you send it
      a.download = `ZMI_Crew_Resume.docx`;
      a.click();

      // Clean up
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading resume:", error);
      toast.error("Failed to generate resume. Try again.");
    }
  };

  return (
    <>
      <div>
        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '16rem',
            }}
          >
            <CircularProgress color="primary" size={60} thickness={5} />
          </Box>

        ) : (
          <div>
            <Navbar />
            {/* Error message */}
            {error && (
              <Box p={4} textAlign="center" bgcolor="#fdecea" color="#b71c1c">
                <Typography color="error" variant="h6">
                  {error}
                </Typography>
              </Box>
            )}
            <Box p={4}>
              <div className="crewProfileTable-container">

                {/* Table Header: Title, Search, and Add Button */}
                <Box mb={4} display="flex" justifyContent="space-between" alignItems="center">
                  {/* Search Bar */}
                  <TextField
                    label="Search by Crew Name / Indos No"
                    variant="outlined"
                    size="small"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    sx={{ maxWidth: 300, backgroundColor: "#f5f5f5" }}
                  />
                  <Box>
                    <Link to="/AssignedCrew">
                      <Button variant="contained" color="primary">Assigned Crew to Crewing Agent</Button>
                    </Link>
                  </Box>

                  <Typography variant="h5" display="flex" alignItems="center" gutterBottom>
                    <FaUserFriends style={{ marginRight: "8px", color: "#007bff" }} />
                    Crew Profile Table
                  </Typography>

                  {/* Buttons Wrapper */}
                  <Box display="flex" gap={1}>
                    <Link to="/crewprofile">
                      <Button variant="contained" color="primary">Add Crew</Button>
                    </Link>
                    <Link to="/RankTable">
                      <Button variant="contained" color="primary">Ranks</Button>
                    </Link>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, padding: "6px 12px", bgcolor: "#fff3cd", borderRadius: "8px" }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: "bold", color: "#856404" }}>
                        Total Crew:
                      </Typography>
                      <Typography variant="h6" sx={{ fontWeight: "bold", color: "#d39e00" }}>
                        {totalCrew}
                      </Typography>
                    </Box>
                  </Box>
                </Box>


                <Paper>
                  <Table sx={{ borderRadius: "8px" }}>
                    <TableHead sx={{ backgroundColor: "#1976D2", height: "30px", borderRadius: "8px" }}>
                      <TableRow>
                        <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                          <Typography sx={{ color: "white", fontWeight: "bold" }}>Sr. No.</Typography>
                        </TableCell>
                        <TableCell sx={{ color: "white", fontWeight: "bold" }}>Personal Info</TableCell>
                        <TableCell sx={{ color: "white", fontWeight: "bold" }}>Info</TableCell>
                        <TableCell sx={{ color: "white", fontWeight: "bold" }}>Documents</TableCell>
                        <TableCell sx={{ color: "white", fontWeight: "bold" }}>Edit</TableCell>
                        <TableCell sx={{ color: "white", fontWeight: "bold" }}>Action</TableCell>
                      </TableRow>

                    </TableHead>
                    <TableBody>
                      {crewProfiles.length > 0 ? (
                        crewProfiles.map((profile, index) => (
                          <TableRow key={profile._id}>
                            <TableCell sx={{ fontSize: "0.85rem", padding: "5px" }}>{index + 1 + (currentPage - 1) * itemsPerPage}</TableCell>
                            <TableCell sx={{ padding: "5px" }}>
                              <Typography sx={{ fontSize: "0.85rem" }}>
                                <strong>Name:</strong> {profile.name || ""
                                  .toLowerCase()
                                  .replace(/\b\w/g, (char) => char.toUpperCase())}
                              </Typography>
                              <Typography sx={{ fontSize: "0.85rem" }}><strong>Indos No:</strong> {profile.indosno}</Typography>
                              <Typography sx={{ fontSize: "0.85rem" }}><strong>Email:</strong> {profile.email}</Typography>
                              <Typography sx={{ fontSize: "0.85rem" }}><strong>Mobile No.:</strong> {profile.mobile}</Typography>
                              {profile?.creatorIdWithName?.[0] && profile?.createdAt && (
                                <Typography sx={{ fontSize: "1rem" }}>
                                  <strong>Created By:</strong>{" "}
                                  {profile.creatorIdWithName[0]?.name
                                    ? `${profile.creatorIdWithName[0].name} - ${dayjs(profile.createdAt).format("DD MMM YYYY")}`
                                    : "-"}
                                </Typography>
                              )}

                              {profile.lastUpdatedBy?.[0] && (<Typography sx={{ fontSize: "1rem" }}><strong>Updated By:</strong>{" "}{profile.lastUpdatedBy[0].name} - {dayjs(profile.lastUpdatedBy[0].updatedDate).format("DD MMM YYYY")}</Typography>)}
                            </TableCell>

                            <TableCell>
                              <Typography sx={{ fontSize: "0.85rem" }}><strong>Rank Name:</strong> {profile.rankname}</Typography>
                              <Typography sx={{ fontSize: "0.85rem" }}><strong>Purpose:</strong> {profile.purpose}</Typography>
                              <Typography sx={{ fontSize: "0.85rem" }}><strong>CDC:</strong> {profile.cdc}</Typography>
                              <Typography sx={{ fontSize: "0.85rem" }}><strong>COC:</strong> {profile.coc}</Typography>
                              <Typography sx={{ fontSize: "0.85rem" }}><strong>CVC Category:</strong> {profile.cvcategory}</Typography>
                            </TableCell>
                            <TableCell sx={{ fontSize: "0.85rem", padding: "5px" }}>
                              {Object.entries(profile || {}).some(
                                ([key, value]) =>
                                  key.toLowerCase() !== "document" && // skip plain 'document'
                                  key.toLowerCase().includes("document") &&
                                  value?.filePath // must contain filePath
                              ) ? (
                    <IconButton onClick={() => handleDocumentClick(profile)}>
  <PictureAsPdfIcon sx={{ color: "red" }} />
</IconButton>

                              ) : (
                                <Typography variant="body2" color="textSecondary">
                                  No Document Available
                                </Typography>
                              )}
                            </TableCell>


                            <TableCell sx={{ fontSize: "0.85rem", padding: "5px" }}>
                              <IconButton onClick={() => handleEdit(profile)} sx={{ color: "blue", "&:hover": { color: "darkblue" } }}>
                                <FaEdit sx={{ color: "blue" }} />
                              </IconButton>
                            </TableCell>
                            <TableCell sx={{ fontSize: "0.85rem", padding: "5px" }}>
                              <Tooltip title="Download Allianz CV">
                                <IconButton onClick={() => GenerateResume(profile._id)}>
                                  <FaFileAlt />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title="Download ZMI CV">
                                <IconButton onClick={() => GenerateZMIResume(profile._id)}>
                                  <FaFileAlt />
                                </IconButton>
                              </Tooltip>

                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={5} sx={{ fontSize: "0.85rem", padding: "5px" }}>
                            <Typography align="center">No crew profiles found</Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </Paper>

                {/* Pagination Controls */}
                <Box mt={4} display="flex" justifyContent="center">
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={(event, page) => handlePageChange(page)}
                    variant="outlined"
                    shape="rounded"


                  />
                </Box>
              </div>
              <ToastContainer />

              {/* PDF Modal */}
             {/* 📄 Modal */}
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: "60%", md: "50%" },
            maxHeight: "80vh",
            bgcolor: "white",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            overflowY: "auto",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{ textAlign: "center", mb: 2, fontWeight: "bold" }}
          >
            {modalTitle}
          </Typography>

        {selectedDocument.length > 0 ? (
  selectedDocument.map((doc, index) => {
    // Find the label from mapping
    const mapping = documentMapping.find((m) => m.key === doc.name);
    const displayName = mapping ? mapping.label : doc.fileName || doc.name;

    return (
      <Paper
        key={index}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
          mb: 2,
          boxShadow: 2,
          borderRadius: 2,
          transition: "0.3s",
          "&:hover": { boxShadow: 4, bgcolor: "#f5f5f5" },
        }}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Typography>{index + 1}.</Typography>
          <PictureAsPdfIcon sx={{ color: "red", mr: 1 }} />
          {/* 👇 Use the mapped label instead of raw name */}
          <Typography variant="body1">{displayName}</Typography>
        </Box>
        <Button
          variant="contained"
          color="primary"
          href={doc.filePath}
          target="_blank"
          rel="noopener noreferrer"
          size="small"
          sx={{ textTransform: "none" }}
        >
          Download
        </Button>
      </Paper>
    );
  })
) : (
  <Typography align="center" color="textSecondary">
    No documents available
  </Typography>
)}

          

          <Box display="flex" justifyContent="center" mt={2}>
            <Button variant="contained" color="error" onClick={handleCloseModal}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
            </Box>

          </div>
        )}
      </div>
    </>
  );
};

export default CrewProfileTable;
